import React, { useState, useEffect } from "react";
import RatingGame from "../../components/RatingGame";
import useGame from "../../hooks/useGame";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";


function shuffleArray(array)
{
  for (let i = array.length - 1; i > 0; i--)
  {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function RandomChar()
{
  var result           = '';
  var characters       = 'abcdefghijklmnopqrstuvwxyz';
  var charactersLength = characters.length;
  result = characters.charAt(Math.floor(Math.random() * charactersLength));
  return result;
}

export default function Rating({ ...props })
{
  const game = useGame(props.game.id);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [levels, setLevels] = useState();
  //console.log("Questions");
  //console.log(questions);

  // once the questions have been retrieved we then generate the questionlist for the rating game
  useEffect(() =>
  {
    if (questions !== undefined)
    {
      let levelQs = [];
      questions.forEach((levelQuestions, i) =>
      {

        var newLevelQuestions = [];
        levelQuestions.forEach(q =>
        {
          console.log(q.question_key);
          for (var i = 1; i < 12; i++) {
            //All the shared variables
            let questionAnswers = [];
            var questionText = "";
            var correctAnswer = "";
            let wrongAnswers = [];
            //First question type
            if(q.question_key === "AlgebraQ1"){
              const theChar = RandomChar();
              const number1 = Math.floor(Math.random() * 6 +5);
              const number2 = Math.floor(Math.random() * (number1-1) +1);
              const theAnswer = number1 - number2;
              questionText = q.question_line_1;
              questionText = questionText.replace('&', theChar).replace('&', theChar).replace('£', theAnswer).replace('^',number1);
              correctAnswer = number2;
              //Create the 3 wrong answers (From -5 to +5 the answer)
              for(var j = 0; j < 3; j++)
              {
                var randAns = correctAnswer + Math.floor(Math.random() * 10 -5);
                while(wrongAnswers.includes(randAns) || randAns == correctAnswer)
                  randAns = correctAnswer + Math.floor(Math.random() * 10 -5);
                wrongAnswers.push(randAns);
              }
            }
            //Second Question type
            if(q.question_key === "AlgebraQ2"){
              const theChar = RandomChar();
              const number1 = Math.floor(Math.random() * 4 +1);
              const number2 = Math.floor(Math.random() * (10-number1) + (number1+1));
              const number3 = number1 + number2;
              questionText = q.question_line_1;
              questionText = questionText.replace('&', theChar).replace('&', theChar).replace('£', number1).replace('^',number2);
              correctAnswer = number3;
              //Create the 3 wrong answers (From -5 to +5 the answer)
              for(var j = 0; j < 3; j++)
              {
                var randAns = correctAnswer + Math.floor(Math.random() * 10 -5);
                while(wrongAnswers.includes(randAns) || randAns == correctAnswer)
                  randAns = correctAnswer + Math.floor(Math.random() * 10 -5);
                wrongAnswers.push(randAns);
              }
            }
            //Third Question type
            if(q.question_key === "AlgebraQ3"){
              const theChar = RandomChar();
              const number1 = Math.floor(Math.random() * 5 +1);
              const number2 = Math.floor(Math.random() * 5 +1);
              const number3 = number1 * number2;
              questionText = q.question_line_1;
              questionText = questionText.replace('&', theChar).replace('&', theChar).replace('£', number1).replace('^',number3);
              correctAnswer = number2;
              //Create the 3 wrong answers (From -5 to +5 the answer)
              for(var j = 0; j < 3; j++)
              {
                var randAns = correctAnswer + Math.floor(Math.random() * 10 -5);
                while(wrongAnswers.includes(randAns) || randAns == correctAnswer)
                  randAns = correctAnswer + Math.floor(Math.random() * 10 -5);
                wrongAnswers.push(randAns);
              }
            }
            //Forth Question type
            if(q.question_key === "AlgebraQ4"){
              const theChar = RandomChar();
              const number1 = Math.floor(Math.random() * 5 +1);
              const number2 = Math.floor(Math.random() * 5 +1);
              const number3 = Math.floor(Math.random() * 5 +1);
              questionText = q.question_line_1;
              questionText = questionText.replace('&', theChar).replace('n&', number2 + theChar).replace('£', number1).replace('*',number3);
              correctAnswer = (number1 * number2) + number3;
              //Create the 3 wrong answers (From -5 to +5 the answer)
              for(var j = 0; j < 3; j++)
              {
                var randAns = correctAnswer + Math.floor(Math.random() * 10 -5);
                while(wrongAnswers.includes(randAns) || randAns == correctAnswer)
                  randAns = correctAnswer + Math.floor(Math.random() * 10 -5);
                wrongAnswers.push(randAns);
              }
            }
            //Fifth Question type
            if(q.question_key === "AlgebraQ5"){
              const theChar = RandomChar();
              const number1 = Math.floor(Math.random() * 5 +1);
              const number2 = Math.floor(Math.random() * 5 +1);
              const number3 = Math.floor(Math.random() * 5 +1);
              questionText = q.question_line_1;
              questionText = questionText.replace('&', theChar).replace('n&', number2 + theChar).replace('£', number1).replace('*',number3);
              correctAnswer = (number1 * number2) - number3;
              //Create the 3 wrong answers (From -5 to +5 the answer)
              for(var j = 0; j < 3; j++)
              {
                var randAns = correctAnswer + Math.floor(Math.random() * 10 -5);
                while(wrongAnswers.includes(randAns) || randAns == correctAnswer)
                  randAns = correctAnswer + Math.floor(Math.random() * 10 -5);
                wrongAnswers.push(randAns);
              }
            }
            //Sixth Question type
            if(q.question_key === "AlgebraQ6"){
              const number1 = Math.floor(Math.random() * 5 +1);
              const number2 = Math.floor(Math.random() * 4 +2);
              var sequence = ' ';
              for(var j = 0; j < 4; j++)
              {
                sequence += (number1 + (number2*j)) + ', ';
              }
              sequence += '%';
              sequence = sequence.replace(', %', '...');
              questionText = q.question_line_1 + sequence;
              correctAnswer = "Add " + number2;
              let randAnswers = [];
              //Create the 3 wrong answers (From -5 to +5 the answer)
              for(var j = 0; j < 3; j++)
              {
                var randAns = number2 + Math.floor(Math.random() * 10 -5);
                while(randAnswers.includes(randAns) || randAns == number2)
                  randAns = number2 + Math.floor(Math.random() * 10 -5);
                  randAnswers.push(randAns);
                  wrongAnswers.push("Add " + randAns);
              }
            }
            //Seventh Question type
            if(q.question_key === "AlgebraQ7"){
              const number1 = Math.floor(Math.random() * 8 + 3);
              const number2 = Math.floor(Math.random() * (number1-1) +1);
              questionText = q.question_line_1;
              questionText = questionText.replace('£', number1)
              correctAnswer = number2 + " and " + (number1 - number2);
              wrongAnswers.push((number2 - 1) + " and " + (number1 - number2));
              wrongAnswers.push(number2 + " and " + (number1 - number2 + 1));
              wrongAnswers.push((number2 + 1) + " and " + (number1 - number2 + 1));
            }
            //Eighth Question type
            if(q.question_key === "AlgebraQ8"){
              const theChar = RandomChar();
              var otherChar = RandomChar();
              while(theChar == otherChar)
                otherChar =  RandomChar();
              const number1 = Math.floor(Math.random() * 5 +1);
              const number2 = Math.floor(Math.random() * 5 +1);
              const number3 = Math.floor(Math.random() * 4 +2);
              const number4 = Math.floor(Math.random() * 4 +2);
              var ansNum = (number1 * number3) + (number2 * number4);
              questionText = q.question_line_1;
              questionText = questionText.replace('£1&1', number1 + theChar).replace('£2&2', number2 + otherChar).replace('^', ansNum);
              correctAnswer = theChar + " = " + number3 + ", " + otherChar + " = " + number4;
              wrongAnswers.push(theChar + " = " + (number3+1) + ", " + otherChar + " = " + number4);
              wrongAnswers.push(theChar + " = " + number3 + ", " + otherChar + " = " + (number4-1));
              wrongAnswers.push(theChar + " = " + (number3-1) + ", " + otherChar + " = " + (number4+1));
            }
            //Ninth Question type
            if(q.question_key === "AlgebraQ9"){
              const theChar = RandomChar();
              var otherChar = RandomChar();
              while(theChar == otherChar)
                otherChar =  RandomChar();
              const number1 = Math.floor(Math.random() * 4 +2);
              questionText = q.question_line_1;
              questionText = questionText.replace('£L1', number1 + theChar).replace('L2', otherChar);
              correctAnswer = number1 + otherChar + theChar;
              wrongAnswers.push((number1+1) + otherChar + theChar);
              wrongAnswers.push((number1) + otherChar + otherChar);
              wrongAnswers.push((number1) + theChar + theChar);
            }
            //Tenth Question type
            if(q.question_key === "AlgebraQ10"){
              const theChar = RandomChar();
              var otherChar = RandomChar();
              while(theChar == otherChar)
                otherChar =  RandomChar();
              const number1 = Math.floor(Math.random() * 4 +2);
              var number2 = Math.floor(Math.random() * 4 +2);
              while(number1 == number2)
                number2 = Math.floor(Math.random() * 4 +2);
              questionText = q.question_line_1;
              questionText = questionText.replace('£1&1', number1 + theChar).replace('£2&2', number2 + otherChar);
              correctAnswer = number2 + otherChar + " + " + number1 + theChar;
              wrongAnswers.push(number2 + theChar + " + " + number1 + otherChar);
              wrongAnswers.push(number2 + otherChar + " + " + number2 + theChar);
              wrongAnswers.push(number1 + otherChar + " + " + number2 + otherChar);
            }
            //Eleventh Question type
            if(q.question_key === "AlgebraQ11"){
              const theChar = RandomChar();
              const number1 = Math.floor(Math.random() * 3 +2);
              var mod = 'double';
              if(number1 == 3)
                mod = 'triple';
              if(number1 == 4)
                mod = 'quadruple';  
              const number2 = Math.floor(Math.random() * 10 +1);
              questionText = q.question_line_1;
              questionText = questionText.replace('*', mod).replace('&', theChar).replace('£',number2);
              correctAnswer = number1 + theChar + " + " + number2;
              wrongAnswers.push((number1 +1) + theChar + " + " + number2);
              wrongAnswers.push(number1 + theChar + " + " + (number2+1));
              wrongAnswers.push((number1 +1) + theChar + " + " + (number2+1));
            }
            //Add the correct answer
            questionAnswers.push({
              correct: true,
              value: correctAnswer
            });
            //Add the wrong answers
            for(var j = 0; j < 3; j++){
              questionAnswers.push({ correct: false, value: wrongAnswers[j] });
            }

            shuffleArray(questionAnswers);

            console.log(questionText + ": " + correctAnswer);
            let questionObj = {
              question: questionText,
              answers: questionAnswers,
              topic_id: q.topic_id
            };

            newLevelQuestions.push(questionObj);
          }
        });
        shuffleArray(newLevelQuestions);
        levelQs[i] = newLevelQuestions;
      });
      setLevels(levelQs);
    }
  }, [questions]);

  return levels !== undefined ? (
    <RatingGame
      questionslist={levels}
      onBack={() =>
      {
        navigate(`/games/${game.id}`);
      }}
      game={game}
      endless={props.endless}
      initialLevel={props.initialLevel}
    />
  ) : (
      <LoadingScreen />
    );
}
